import { useState } from "react";
import { DEMO_USER } from "../constants/theme";

// ─── USE AUTH ─────────────────────────────────────────────────────────────────
// Manages authentication state for RevCentriQ.
//
// Currently: demo credentials only (no backend).
// Phase 2: Replace internals with Supabase auth — the hook interface stays
// identical so no page-level code needs to change.
//
// Usage:
//   const { user, login, logout, loading, error } = useAuth();

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const login = async ({ email, password }) => {
    setError("");
    setLoading(true);

    // TODO Phase 2: Replace with Supabase auth
    // const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    return new Promise((resolve) => {
      setTimeout(() => {
        if (email === DEMO_USER.email && password === DEMO_USER.password) {
          const userData = { ...DEMO_USER, isNew: false };
          setUser(userData);
          setLoading(false);
          resolve({ user: userData, error: null });
        } else {
          setError("Invalid email or password.");
          setLoading(false);
          resolve({ user: null, error: "Invalid credentials" });
        }
      }, 1000);
    });
  };

  const signup = async ({ email, password, name, company }) => {
    setError("");
    setLoading(true);

    // TODO Phase 2: Replace with Supabase auth
    // const { data, error } = await supabase.auth.signUp({ email, password });
    return new Promise((resolve) => {
      setTimeout(() => {
        const userData = { email, name, company, role: "", isNew: true };
        setUser(userData);
        setLoading(false);
        resolve({ user: userData, error: null });
      }, 1000);
    });
  };

  const logout = () => {
    // TODO Phase 2: await supabase.auth.signOut();
    setUser(null);
    setError("");
  };

  return { user, loading, error, setError, login, signup, logout };
}
